import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';

import css from './NoMessage.module.scss';

type NoMessageProps = {
    category: string;
};

const NoMessage = ({ category }: NoMessageProps) => {
    const { t } = useTranslateLpc(['lpc-greeting-card']);

    return (
        <div className={css.card}>
            <img src="/front-static/icons/display/no-smile_.svg" alt="no-smile" />
            <h5> {t('no-message.title')}</h5>
            <Text variant={'caption_02'} color={'txt-secondary'}>
                {category === 'BEREAVEMENT' ? t('no-message.desc-bereavement') : t('no-message.desc')}
            </Text>
        </div>
    );
};

export default NoMessage;
